<template>
  <PropertyDetailsCard>
    <template #title>Included utilities</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyIncludedUtilitiesInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added included utilities yet"
      subtitle="List all included utilities to provide clear expectations for Renters"
      button-text="Add included utilities"
      @button-clicked="showModal"
    />
    <PropertyIncludedUtilitiesModal ref="includedUtilitiesModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyIncludedUtilitiesInfo,
} from '@tallo/property';

import PropertyIncludedUtilitiesModal from './property-included-utilities-modal.vue';

const includedUtilitiesModalRef = ref<InstanceType<typeof PropertyIncludedUtilitiesModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.includedUtilities));

function showModal() {
  includedUtilitiesModalRef.value?.modalRef?.show();
}
</script>
